import Vue from 'vue';
import Component from 'vue-class-component';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
]);
import Router from 'vue-router';
import { Authority } from '@/shared/security/authority';
const Home = () => import('../core/home/home.vue');
const Error = () => import('../core/error/error.vue');
const Register = () => import('../account/register/register.vue');
const Activate = () => import('../account/activate/activate.vue');
const ResetPasswordInit = () => import('../account/reset-password/init/reset-password-init.vue');
const ResetPasswordFinish = () => import('../account/reset-password/finish/reset-password-finish.vue');
const ChangePassword = () => import('../account/change-password/change-password.vue');
const Settings = () => import('../account/settings/settings.vue');
const JhiUserManagementComponent = () => import('../admin/user-management/user-management.vue');
const JhiUserManagementViewComponent = () => import('../admin/user-management/user-management-view.vue');
const JhiUserManagementEditComponent = () => import('../admin/user-management/user-management-edit.vue');
const JhiConfigurationComponent = () => import('../admin/configuration/configuration.vue');
const JhiDocsComponent = () => import('../admin/docs/docs.vue');
const JhiHealthComponent = () => import('../admin/health/health.vue');
const JhiLogsComponent = () => import('../admin/logs/logs.vue');
const JhiAuditsComponent = () => import('../admin/audits/audits.vue');
const JhiMetricsComponent = () => import('../admin/metrics/metrics.vue');
const JhiTrackerComponent = () => import('../admin/tracker/tracker.vue');
/* tslint:disable */
// prettier-ignore
const Dialogue = () => import('../entities/dialogue/dialogue.vue');
// prettier-ignore
const DialogueUpdate = () => import('../entities/dialogue/dialogue-update.vue');
// prettier-ignore
const DialogueDetails = () => import('../entities/dialogue/dialogue-details.vue');
// prettier-ignore
const DialogueState = () => import('../entities/dialogue/dialogue-state.vue');
// prettier-ignore
const Utterance = () => import('../entities/utterance/utterance.vue');
// prettier-ignore
const UtteranceUpdate = () => import('../entities/utterance/utterance-update.vue');
// prettier-ignore
const UtteranceDetails = () => import('../entities/utterance/utterance-details.vue');
// prettier-ignore
const Person = () => import('../entities/person/person.vue');
// prettier-ignore
const PersonUpdate = () => import('../entities/person/person-update.vue');
// prettier-ignore
const PersonDetails = () => import('../entities/person/person-details.vue');
// prettier-ignore
const Sentence = () => import('../entities/sentence/sentence.vue');
// prettier-ignore
const SentenceUpdate = () => import('../entities/sentence/sentence-update.vue');
// prettier-ignore
const SentenceDetails = () => import('../entities/sentence/sentence-details.vue');
// prettier-ignore
const Word = () => import('../entities/word/word.vue');
// prettier-ignore
const WordUpdate = () => import('../entities/word/word-update.vue');
// prettier-ignore
const WordDetails = () => import('../entities/word/word-details.vue');
// prettier-ignore
const DependencyGraph = () => import('../entities/dependency-graph/dependency-graph.vue');
// prettier-ignore
const DependencyGraphUpdate = () => import('../entities/dependency-graph/dependency-graph-update.vue');
// prettier-ignore
const DependencyGraphDetails = () => import('../entities/dependency-graph/dependency-graph-details.vue');
// prettier-ignore
const Metadata = () => import('../entities/metadata/metadata.vue');
// prettier-ignore
const MetadataUpdate = () => import('../entities/metadata/metadata-update.vue');
// prettier-ignore
const MetadataDetails = () => import('../entities/metadata/metadata-details.vue');
// prettier-ignore
const Customer = () => import('../entities/customer/customer.vue');
// prettier-ignore
const CustomerUpdate = () => import('../entities/customer/customer-update.vue');
// prettier-ignore
const CustomerDetails = () => import('../entities/customer/customer-details.vue');
// prettier-ignore
const Address = () => import('../entities/address/address.vue');
// prettier-ignore
const AddressUpdate = () => import('../entities/address/address-update.vue');
// prettier-ignore
const AddressDetails = () => import('../entities/address/address-details.vue');
// prettier-ignore
const BankAccount = () => import('../entities/bank-account/bank-account.vue');
// prettier-ignore
const BankAccountUpdate = () => import('../entities/bank-account/bank-account-update.vue');
// prettier-ignore
const BankAccountDetails = () => import('../entities/bank-account/bank-account-details.vue');
// prettier-ignore
const PaymentCard = () => import('../entities/payment-card/payment-card.vue');
// prettier-ignore
const PaymentCardUpdate = () => import('../entities/payment-card/payment-card-update.vue');
// prettier-ignore
const PaymentCardDetails = () => import('../entities/payment-card/payment-card-details.vue');
// prettier-ignore
const ModelVersion = () => import('../entities/model-version/model-version.vue');
// prettier-ignore
const ModelVersionUpdate = () => import('../entities/model-version/model-version-update.vue');
// prettier-ignore
const ModelVersionDetails = () => import('../entities/model-version/model-version-details.vue');
// prettier-ignore
const Email = () => import('../entities/email/email.vue');
// prettier-ignore
const EmailUpdate = () => import('../entities/email/email-update.vue');
// prettier-ignore
const EmailDetails = () => import('../entities/email/email-details.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/account/activate',
      name: 'Activate',
      component: Activate
    },
    {
      path: '/account/reset/request',
      name: 'ResetPasswordInit',
      component: ResetPasswordInit
    },
    {
      path: '/account/reset/finish',
      name: 'ResetPasswordFinish',
      component: ResetPasswordFinish
    },
    {
      path: '/account/password',
      name: 'ChangePassword',
      component: ChangePassword,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/account/settings',
      name: 'Settings',
      component: Settings,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/admin/user-management',
      name: 'JhiUser',
      component: JhiUserManagementComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/user-management/new',
      name: 'JhiUserCreate',
      component: JhiUserManagementEditComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/user-management/:userId/edit',
      name: 'JhiUserEdit',
      component: JhiUserManagementEditComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/user-management/:userId/view',
      name: 'JhiUserView',
      component: JhiUserManagementViewComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/docs',
      name: 'JhiDocsComponent',
      component: JhiDocsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/audits',
      name: 'JhiAuditsComponent',
      component: JhiAuditsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/jhi-health',
      name: 'JhiHealthComponent',
      component: JhiHealthComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/logs',
      name: 'JhiLogsComponent',
      component: JhiLogsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/jhi-metrics',
      name: 'JhiMetricsComponent',
      component: JhiMetricsComponent,
      meta: { authorities: [Authority.ADMIN] }
    },
    {
      path: '/admin/jhi-configuration',
      name: 'JhiConfigurationComponent',
      component: JhiConfigurationComponent,
      meta: { authorities: [Authority.ADMIN] }
    }
,
    {
      path: '/admin/jhi-tracker',
      name: 'JhiTrackerComponent',
      component: JhiTrackerComponent,
      meta: { authorities: [Authority.ADMIN] }
    }
    ,
    {
      path: '/dialogue',
      name: 'Dialogue',
      component: Dialogue,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dialogue/new',
      name: 'DialogueCreate',
      component: DialogueUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dialogue/:dialogueId/edit',
      name: 'DialogueEdit',
      component: DialogueUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dialogue/:dialogueId/view',
      name: 'DialogueView',
      component: DialogueDetails,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dialogue/:dialogueId/state',
      name: 'DialogueState',
      component: DialogueState,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/utterance',
      name: 'Utterance',
      component: Utterance,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/utterance/new',
      name: 'UtteranceCreate',
      component: UtteranceUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/utterance/:utteranceId/edit',
      name: 'UtteranceEdit',
      component: UtteranceUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/utterance/:utteranceId/view',
      name: 'UtteranceView',
      component: UtteranceDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/person',
      name: 'Person',
      component: Person,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/person/new',
      name: 'PersonCreate',
      component: PersonUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/person/:personId/edit',
      name: 'PersonEdit',
      component: PersonUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/person/:personId/view',
      name: 'PersonView',
      component: PersonDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/sentence',
      name: 'Sentence',
      component: Sentence,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/sentence/new',
      name: 'SentenceCreate',
      component: SentenceUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/sentence/:sentenceId/edit',
      name: 'SentenceEdit',
      component: SentenceUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/sentence/:sentenceId/view',
      name: 'SentenceView',
      component: SentenceDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/word',
      name: 'Word',
      component: Word,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/word/new',
      name: 'WordCreate',
      component: WordUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/word/:wordId/edit',
      name: 'WordEdit',
      component: WordUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/word/:wordId/view',
      name: 'WordView',
      component: WordDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/dependency-graph',
      name: 'DependencyGraph',
      component: DependencyGraph,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dependency-graph/new',
      name: 'DependencyGraphCreate',
      component: DependencyGraphUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dependency-graph/:dependencyGraphId/edit',
      name: 'DependencyGraphEdit',
      component: DependencyGraphUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/dependency-graph/:dependencyGraphId/view',
      name: 'DependencyGraphView',
      component: DependencyGraphDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/metadata',
      name: 'Metadata',
      component: Metadata,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/metadata/new',
      name: 'MetadataCreate',
      component: MetadataUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/metadata/:metadataId/edit',
      name: 'MetadataEdit',
      component: MetadataUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/metadata/:metadataId/view',
      name: 'MetadataView',
      component: MetadataDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/customer',
      name: 'Customer',
      component: Customer,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/customer/new',
      name: 'CustomerCreate',
      component: CustomerUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/customer/:customerId/edit',
      name: 'CustomerEdit',
      component: CustomerUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/customer/:customerId/view',
      name: 'CustomerView',
      component: CustomerDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/address',
      name: 'Address',
      component: Address,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/address/new',
      name: 'AddressCreate',
      component: AddressUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/address/:addressId/edit',
      name: 'AddressEdit',
      component: AddressUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/address/:addressId/view',
      name: 'AddressView',
      component: AddressDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/bank-account',
      name: 'BankAccount',
      component: BankAccount,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/bank-account/new',
      name: 'BankAccountCreate',
      component: BankAccountUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/bank-account/:bankAccountId/edit',
      name: 'BankAccountEdit',
      component: BankAccountUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/bank-account/:bankAccountId/view',
      name: 'BankAccountView',
      component: BankAccountDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/payment-card',
      name: 'PaymentCard',
      component: PaymentCard,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/payment-card/new',
      name: 'PaymentCardCreate',
      component: PaymentCardUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/payment-card/:paymentCardId/edit',
      name: 'PaymentCardEdit',
      component: PaymentCardUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/payment-card/:paymentCardId/view',
      name: 'PaymentCardView',
      component: PaymentCardDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/model-version',
      name: 'ModelVersion',
      component: ModelVersion,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/model-version/new',
      name: 'ModelVersionCreate',
      component: ModelVersionUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/model-version/:modelVersionId/edit',
      name: 'ModelVersionEdit',
      component: ModelVersionUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/model-version/:modelVersionId/view',
      name: 'ModelVersionView',
      component: ModelVersionDetails,
      meta: { authorities: [Authority.USER] }
    }
    ,
    {
      path: '/email',
      name: 'Email',
      component: Email,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/email/new',
      name: 'EmailCreate',
      component: EmailUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/email/:emailId/edit',
      name: 'EmailEdit',
      component: EmailUpdate,
      meta: { authorities: [Authority.USER] }
    },
    {
      path: '/email/:emailId/view',
      name: 'EmailView',
      component: EmailDetails,
      meta: { authorities: [Authority.USER] }
    }
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ]
});
